import { Link, useLocation, useParams } from "react-router-dom";
import { Button, Card, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import BaseLayout from "../../components/layout";
import Footer from "../../components/layout/footers/Footer";
import { ROUTE } from "../../constants/app_routes";
import { FaRegCopy } from "react-icons/fa";

const CoinDetail = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { symbol } = useParams();

  const coinName = (symbol || "").toUpperCase();
  const address = state?.address?.address || "-";
  const addressOmni = state?.address_omni?.address || "-";
  const addressErc20 = state?.address_erc20?.address || "-";

  return (
    <BaseLayout>
      <div className="topup">
        <Container className="mt-2">
          <Card>
            <Card.Body>
              <h3 className="mb-3">
                {coinName} {t("detail")}
              </h3>
              <div className="mb-4">
                <h4>{coinName}:</h4>
                <div
                  className="p-3 "
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    wordBreak: "break-all",
                    fontSize: "12px",
                  }}
                >
                  {address}{" "}
                  <FaRegCopy
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(address);
                    }}
                  />
                </div>
              </div>
              <div className="mb-4">
                <h4>{coinName} (Omni): </h4>
                <div
                  className="p-3 "
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    wordBreak: "break-all",
                    fontSize: "12px",
                  }}
                >
                  {addressOmni}{" "}
                  <FaRegCopy
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(addressOmni);
                    }}
                  />
                </div>
              </div>
              <div className="mb-4">
                <h4>{coinName} (ERC20): </h4>
                <div
                  className="p-3 "
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    wordBreak: "break-all",
                    fontSize: "12px",
                  }}
                >
                  {addressErc20}{" "}
                  <FaRegCopy
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(addressErc20);
                    }}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>

          <div className="text-center mt-3">
            <Link to={ROUTE.TOPUP}>
              <Button variant="secondary">{t("back")}</Button>
            </Link>
          </div>
        </Container>
        <Footer />
      </div>
    </BaseLayout>
  );
};

export default CoinDetail;
